import React from "react";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Divider,
  Card,
  Grid,
} from "@mui/material";

const cardStyle = {
  padding: 2,
  backgroundColor: "#fff",
  borderRadius: 2,
  boxShadow: 3,
  borderTop: "4px solid #7FFFD4",
  "&:hover": {
    boxShadow: 6, // Hover effect
    transform: "scale(1.05)", // Slight zoom on hover
    transition: "0.3s",
  },
};

const titleStyle = {
  fontWeight: "bold",
  color: "#333",
  fontSize: "0.875rem", // Slightly smaller font for labels
};

const dataStyle = {
  fontWeight: "bold",
  fontSize: "1.25rem",
  color: "#097969", // Highlight color for data values
};

const listStyle = {
  color: "#555",
};

const LeaveReportDesign = ({ reportData }) => {
  // Destructure data from reportData prop
  const { message, allLeaves, summary } = reportData;
  const {
    totalLeaveRequests,
    uniqueEmployeesOnLeave,
    leavesByType,
    leavesByRegion,
  } = summary;

  return (
    <Paper sx={{ padding: 3, marginTop: 3, borderRadius: 2, boxShadow: 3 }}>
      <Box sx={{ padding: 3, backgroundColor: "#f9f9f9" }}>
        {/* Report Summary Header */}
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "#333", marginBottom: 3 }}
        >
          Leave Summary
        </Typography>

        <Grid container spacing={3}>
          {/* Total Leave Requests Card */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={cardStyle}>
              <Typography variant="body2" sx={titleStyle}>
                Total Leave Requests
              </Typography>
              <Typography variant="h6" sx={dataStyle}>
                {" "}
                {totalLeaveRequests}{" "}
              </Typography>
            </Card>
          </Grid>

          {/* Unique Employees on Leave Card */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={cardStyle}>
              <Typography variant="body2" sx={titleStyle}>
                Unique Employees on Leave
              </Typography>
              <Typography variant="h6" sx={dataStyle}>
                {uniqueEmployeesOnLeave}
              </Typography>
            </Card>
          </Grid>

          {/* Leaves by Type Card */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={cardStyle}>
              <Typography variant="body2" sx={titleStyle}>
                Leaves by Type
              </Typography>
              {Object.entries(leavesByType).map(([leaveType, count]) => (
                <Box key={leaveType} sx={{ marginTop: 1 }}>
                  <Typography variant="body2" sx={listStyle}>
                    {leaveType}: <strong>{count}</strong>
                  </Typography>
                </Box>
              ))}
            </Card>
          </Grid>

          {/* Leaves by Region Card */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={cardStyle}>
              <Typography variant="body2" sx={titleStyle}>
                Leaves by Region
              </Typography>
              {Object.entries(leavesByRegion).map(([region, count]) => (
                <Box key={region} sx={{ marginTop: 1 }}>
                  <Typography variant="body2" sx={listStyle}>
                    {region}: <strong>{count}</strong>
                  </Typography>
                </Box>
              ))}
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ marginY: 2 }} />

      {/* Leave Details Table */}
      <TableContainer
        sx={{ marginTop: 2, borderRadius: 1, overflow: "hidden", boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#f1f1f1" }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                SNo
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                Employee Name
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                Leave Type
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                Leave Dates
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                Remarks
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allLeaves.length === 0 ? (
              <>
              <TableRow>
                <TableCell colSpan={5}>No Data available yet.</TableCell>
              </TableRow>
              </>
            ) : (allLeaves.map((leave, index) => {
              const { employeeName, leaveType, startDate, endDate, remarks } =
                leave;
              return (
                <TableRow
                  key={leave.leaveId}
                  sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}
                >
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{employeeName}</TableCell>
                  <TableCell align="center">{leaveType}</TableCell>
                  <TableCell align="center">
                    {startDate} to {endDate}
                  </TableCell>
                  <TableCell align="center">{remarks}</TableCell>
                </TableRow>
              );
            }))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default LeaveReportDesign;
